/* eslint-disable react/jsx-no-bind */
import { useState, useEffect } from 'react'
import { Link } from '@material-ui/core'
import AlertDialog, { AlertDialogProps } from 'baby-ui/compounds/AlertDialog'
import { track, useTracking } from 'lib/babylistHealthAnalytics'
import {
  UNSUPPORTED_INSURANCE_PLAN_MODAL,
  UNSUPPORTED_STATE_MODAL,
} from './InsurancePickerForm.constants'
import { dialogMap } from './misc'
import { STORE_NAME, EDGEPARK_REFERRAL_URL } from '../../constants'
import InsuranceNameForm, {
  InsuranceNameFormValues,
} from '../InsuranceNameForm'

export interface UnsupportedSelectionDialogProps
  extends Omit<AlertDialogProps, 'children' | 'title'> {
  dialogName: 'unsupportedStateModal' | 'unsupportedInsurancePlanModal'
  inputValue?: string
}

export default function UnsupportedSelectionDialog({
  dialogName,
  open,
  onClose,
  inputValue,
}: UnsupportedSelectionDialogProps) {
  const tracker = useTracking()
  const [providedInsuranceName, setProvidedInsuranceName] = useState<
    null | string
  >(null)

  const shouldFireUnsupportedStateSelectedEvent =
    dialogName === UNSUPPORTED_STATE_MODAL
  const shouldFireUnsupportedInsuranceProviderSelectedEvent =
    dialogName === UNSUPPORTED_INSURANCE_PLAN_MODAL && providedInsuranceName

  function fireUnsupportedStateSelectedEvent() {
    tracker.trackEvent({
      event: track.unsupportedStateSelected,
      state: inputValue,
      storeName: STORE_NAME,
    })
  }

  function fireUnsupportedInsuranceProviderSelected() {
    tracker.trackEvent({
      event: track.unsupportedInsuranceProviderSelected,
      insuranceName: providedInsuranceName,
      storeName: STORE_NAME,
    })
  }

  useEffect(() => {
    if (open) {
      if (shouldFireUnsupportedStateSelectedEvent) {
        fireUnsupportedStateSelectedEvent()
      } else if (shouldFireUnsupportedInsuranceProviderSelectedEvent) {
        fireUnsupportedInsuranceProviderSelected()
      }
    }
  }, [open, dialogName, inputValue, providedInsuranceName])

  function getTitle() {
    if (dialogName === UNSUPPORTED_INSURANCE_PLAN_MODAL) {
      if (providedInsuranceName) {
        return dialogMap[dialogName].titleB
      }

      return dialogMap[dialogName].titleA
    }

    return dialogMap[dialogName].title
  }

  function handleOnSubmit(value: InsuranceNameFormValues) {
    setProvidedInsuranceName(value.insuranceProviderName)
  }

  function getBody() {
    const commonBody = (
      <>
        {dialogMap[dialogName].description}
        <ul>
          <li>
            <Link href={EDGEPARK_REFERRAL_URL}>Edgepark</Link>
          </li>
        </ul>
      </>
    )

    if (dialogName === UNSUPPORTED_INSURANCE_PLAN_MODAL) {
      if (providedInsuranceName) {
        return commonBody
      }

      return <InsuranceNameForm onSubmit={handleOnSubmit} />
    }

    return commonBody
  }

  return (
    <AlertDialog open={open} title={getTitle()} onClose={onClose}>
      {getBody()}
    </AlertDialog>
  )
}
